import Input from 'components/Input';
import { useTranslate } from 'hooks/translation-hooks';
import { camelToSnakeCase } from 'utils/global-utils';

const GenericInput = ({
  register,
  errors,
  category,
  element,
  elementPattern,
}) => {
  const t = useTranslate('caseOpening');
  const pattern = new RegExp(elementPattern);
  const snake_case_element = camelToSnakeCase(element);
  return (
    <Input
      name={element}
      {...register(element, {
        required: true,
        pattern,
      })}
      category={category}
      testId={element}
      maxLength={20}
      error={
        errors[element] &&
        `case_identification-${snake_case_element}_error_format`
      }
      label={t(`case_identification-${snake_case_element}`)}
      placeholder={t(`case_identification-${snake_case_element}-placeholder`)}
    />
  );
};

export default GenericInput;
